"use strict";
/**
 * Override all anchor tags that references to an in page element, to add easing scroll.
 */
document.addEventListener('DOMContentLoaded', () => {
    const anchorElements = document.querySelectorAll('a[href^="#"]');
    if (anchorElements.length > 0) {
        anchorElements.forEach((element) => {
            const targetElementId = element.getAttribute('href');
            if (targetElementId === '#') {
                return;
            }
            element.addEventListener('click', (event) => {
                event.preventDefault();
                const targetElement = document.querySelector(targetElementId);
                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop - 100,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }
});
